import React from "react";
import ReactDOMServer from "react-dom/server";
import logoMombasa from "../../core/img/branch-logos/logo_mombasa.jpg";
import logoNairobi from "../../core/img/branch-logos/logo_nairobi.jpg";
import logoSystems from "../../core/img/branch-logos/logo_systems.jpg";
import logoTexastrack from "../../core/img/branch-logos/logo_texastrack.png";

// Shared popup-print plumbing for any one-off document sheet. Same approach as
// the Duty List print: static markup (inline styles only - the popup has no
// stylesheet) written into a blank window, which prints itself; the browser dialog
// also saves as PDF, and table headers repeat on every page.
//
// Moved out of features/alarms (2026-09-18) on its third consumer - Client Visit
// and Stock Adjustment needed the identical popup/pop-up-blocker/image-wait
// handling, and none of this is alarm-specific.
const LOGO_BY_BRANCH = { MOMBASA: logoMombasa, NAIROBI: logoNairobi, SYSTEMS: logoSystems, TEXASTRACK: logoTexastrack };

export const PRINT_BASE = { fontFamily: "Arial, Helvetica, sans-serif", color: "#000" };
export const PRINT_TH = { padding: "4px 5px", fontSize: "10.5px", borderBottom: "1.5px solid #000", background: "#eee", textAlign: "left", verticalAlign: "bottom" };
export const PRINT_TD = { padding: "3px 5px", fontSize: "10.5px", borderBottom: "1px solid #ccc", verticalAlign: "top" };

export const PrintHeader = ({ title, subtitle, lines = [], branchCode }) => (
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "8px" }}>
    <div>
      <div style={{ fontSize: "17px", fontWeight: 700 }}>{title}</div>
      {subtitle && <div style={{ fontSize: "11.5px" }}>{subtitle}</div>}
      {lines.filter(Boolean).map((l) => (
        <div key={l} style={{ fontSize: "11px" }}>{l}</div>
      ))}
    </div>
    <div style={{ textAlign: "right" }}>
      <img src={LOGO_BY_BRANCH[branchCode] || logoMombasa} alt="" style={{ height: "40px", objectFit: "contain" }} />
      <div style={{ fontSize: "9.5px", color: "#555" }}>Printed {new Date().toLocaleString("en-GB")}</div>
    </div>
  </div>
);

/** `win` = a window the caller already opened during the click (see AlarmSheetPrintButton). */
export const printElement = (element, { title, page = "A4 portrait", win: openedWin }) => {
  const bodyHtml = ReactDOMServer.renderToStaticMarkup(element);
  const win = openedWin || window.open("", "_blank", "width=1100,height=900");
  if (!win) return false;
  win.document.open();
  win.document.write(
    `<html><head><title>${title}</title>` +
      `<style>@page { size: ${page}; margin: 8mm; } html,body { margin:0; padding:0; }` +
      ` thead { display: table-header-group; } tr { page-break-inside: avoid; }` +
      ` * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }</style>` +
      // Wait for images (photos, logo) before printing, or they come out blank.
      `</head><body>${bodyHtml}<script>` +
      `Promise.all(Array.from(document.images).map(i => i.complete ? 0 : new Promise(r => { i.onload = i.onerror = r; })))` +
      `.then(() => { window.print(); window.close(); });</script></body></html>`
  );
  win.document.close();
  return true;
};

export const blobToDataUrl = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
